import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import DayMonthYearError from '../../components/checkout/DayMonthYear/DayMonthYearError';

const DayMonthYearErrorContainer = props =>
  <Field
    name={props.name}
    component={DayMonthYearError}
    props={props}
  />
;

DayMonthYearErrorContainer.propTypes = {
  name: PropTypes.string
};

export default DayMonthYearErrorContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/DayMonthYearErrorContainer.js
 **/